(function($) {

    $('.scroll-to').on('click', function() {
        if (this.hash !== "") {
            event.preventDefault();
            var hash = this.hash;

            $("html, body").animate({
                scrollTop: $(hash).offset().top
            }, 500, function() {
                window.location.hash = hash; // Add hash to url
            });
        }
    });

}(jQuery));